import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { StringParam, withDefault, useQueryParams } from 'use-query-params';
import withQueryParamsProvider from '../../../../../../shared/components/withQueryParamsProvider';
import VerificationContent from './VerificationContent';

const ConfigurationTab = ({ affiliateId }) => {
  const [query, setQuery] = useQueryParams({
    tab: withDefault(StringParam, ''),
  });

  const { tab } = query;

  useEffect(() => {
    setQuery({ tab: 'configuration' }, 'replaceIn');
  }, [tab]);

  return <VerificationContent affiliateId={affiliateId} />;
};

ConfigurationTab.propTypes = {
  affiliateId: PropTypes.number.isRequired,
};

export default withQueryParamsProvider(ConfigurationTab);
